export default "__VITE_ASSET__3317c034__"